angular.module('tgaAdmin')
  .controller('GameFlashController', [
    '$scope', '$timeout', 'gameService', '$filter',
    function (
      $scope, $timeout, gameService, $filter,
    ) {
      $scope.data.gameModes = [{
        key: 'standard',
        name: 'Single Player',
      }, {
        key: 'instructor_initiated',
        name: 'Instructor Initiated',
      }];

      $scope.data.questionTypes = [{
        id: 'text_input',
        name: 'Text Input',
      }];

      $scope.data.matchTypes = [{
        id: null,
        name: 'Exact',
      }, {
        id: 'contains',
        name: 'Contains',
      }, {
        id: 'starts_with',
        name: 'Starts With',
      }, {
        id: 'ends_with',
        name: 'Ends With',
      }, {
        id: 'inside',
        name: 'Inside',
      }];

      $scope.logo_300x125_tooltip = $filter('translate')('game.flash.logo_300x125');
      $scope.logo_600x200_tooltip = $filter('translate')('game.flash.logo_600x200');
      $scope.logo_800x267_tooltip = $filter('translate')('game.flash.logo_800x267');

      $scope.actions.addQuestionGroup = function () {
        const question_group = {
          game_id: $scope.viewmodel.game.game_id,
          name: $scope.data.new_category,
          sort_order: $scope.viewmodel.game.question_groups.length,
        };

        $scope.addingCategory = true;

        gameService.addQuestionGroup(question_group).then((response) => {
          $scope.gameForm.$setDirty();
          $scope.viewmodel.game.question_groups = response;
          $scope.data.new_category = null;
          $scope.addingCategory = false;
        });
      };

      $scope.actions.deleteQuestionGroup = function (group) {
        $scope.gameForm.$setDirty();
        $scope.viewmodel.game.question_groups.splice($scope.viewmodel.game.question_groups.indexOf(group), 1);
      };

      $scope.actions.toggleFeedbackCollapse = function (group, g_index, c_index, q_index, f_index) {
        // toggle accordion
        // eslint-disable-next-line max-len
        group.question_groups[c_index].questions[q_index].advanced_feedback[f_index].isOpen = !group.question_groups[c_index].questions[q_index].advanced_feedback[f_index].isOpen;

        // reset others
        for (let i = 0; i < group.question_groups[c_index].questions[q_index].advanced_feedback.length; i++) {
          if (i !== f_index) {
            group.question_groups[c_index].questions[q_index].advanced_feedback[i].isOpen = false;
          }
        }

        $timeout(() => {
          $('html, body').stop(true, false).animate({
            scrollTop: $('#parent-group').children('.panel').eq(g_index).find('.category-group')
              .eq(c_index)
              .find('.panel')
              .eq(q_index)
              .find('.panel')
              .eq(f_index)
              .offset().top - 120,
          }, 250);
        }, 10);
      };

      $scope.actions.verifyQuestionGroups = function () {
        $scope.actions.submit(true);
      };
    }]);
